import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  const links = [{
    label: 'About us',
    href: '/about',
    isInternal: true
  }, {
    label: 'Careers',
    href: 'https://jobs.gem.com/fifthdoor-com',
    isInternal: false
  }, {
    label: 'Discord',
    href: 'https://discord.gg/HCC76Zt82Y',
    isInternal: false
  }];
  return <footer className="w-full relative overflow-hidden" style={{
    backgroundColor: '#000000',
    paddingTop: '2rem'
  }} data-id="element-44">
      {/* Noise texture overlay */}
      <div className="absolute inset-0 pointer-events-none" style={{
      backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/bonQpX7FQKEhKvnQfRNJtT/noise-background.png)',
      backgroundRepeat: 'repeat',
      backgroundSize: '200px 200px',
      opacity: 0.24
    }} data-id="element-45" />

      <div className="relative z-10 w-full" data-id="element-46">
        <div className="max-w-7xl mx-auto px-4" data-id="element-47">
          {/* Navigation Links */}
          <div className="flex justify-between items-center mb-6 md:mb-8 px-4 md:px-12" data-id="element-48">
            {links.map(link => link.isInternal ? <Link key={link.label} to={link.href} onClick={() => window.scrollTo(0, 0)} className="text-white font-medium hover:opacity-80 transition-opacity" style={{
            fontFamily: "'Instrument Sans', sans-serif",
            fontSize: '16px'
          }} data-id="element-49">
                  {link.label}
                </Link> : <a key={link.label} href={link.href} className="text-white font-medium hover:opacity-80 transition-opacity" style={{
            fontFamily: "'Instrument Sans', sans-serif",
            fontSize: '16px'
          }} data-id="element-50">
                  {link.label}
                </a>)}
          </div>
        </div>

        {/* Green Separator Line - Full Width */}
        <div className="w-full h-px mb-8 md:mb-12" style={{
        backgroundColor: '#074030',
        opacity: 0.5
      }} data-id="element-51" />

        <div className="max-w-7xl mx-auto px-4" data-id="element-52">
          {/* Large Logo */}
          <div className="w-full" data-id="element-53">
            <img src="https://cdn.magicpatterns.com/uploads/oaMs6zp7hbUHVrxri2Qay2/fifth-door-dooter-logo.png" alt="Fifth Door" className="w-full h-auto object-contain" style={{
            display: 'block',
            maxWidth: '100%'
          }} data-id="element-54" />
          </div>
        </div>
      </div>
    </footer>;
}